import { DesignedButton, DesignedCard, Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { BlueUnderline } from "@with-nx/simple-ui/molecules";
import {
  AutoScroller,
  CatalogLayout,
  FeaturesContainer,
  ProductLandingHero,
} from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";
import { Box } from "simple-effing-primitive-layout";

const TimelineGraphic = () => {
  return (
    <AutoScroller
      top={0}
      manual={true}
      background="var(--background)"
      paddings={50}
      duration={20}
    >
      <img
        src="/assets/section/timeline.webp"
        loading="lazy"
        alt="Broadway Media Timeline"
        style={{
          width: 6942,
          minWidth: 6942,
          height: 400,
          display: "block",
          pointerEvents: "none",
          mixBlendMode: "lighten",
          backgroundColor: "var(--background)",
        }}
      />
    </AutoScroller>
  );
};

export default function Page({ resolvedUrl }) {
  const jobsLink =
    "https://jobs.gusto.com/boards/broadway-media-e3a2c4ff-a193-43fb-950c-9682ef4cf443";

  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Careers"
      resolvedUrl={resolvedUrl}
    >
      <ProductLandingHero
        title="Careers"
        description="Broadway Media’s team of Theatre-Makers are driven by our passion and our purpose to strengthen the performing arts community"
        primaryButtonLabel="See Open Positions"
        primaryButtonHref={jobsLink}
        secondaryButtonLabel="Contact Us"
        secondaryButtonHref="/contact"
        imagePosition="center top"
        image="/assets/hero/blue-gradient-hero-small.png"
        minHeight={400}
      />
      <ReusableSection>
        <div className="container">
          <Box
            css="d:flex a:baseline j:flex-start p:relative oy:visible fw:wrap"
            parse="mb:24"
          >
            <Rule
              parse="!hl d:inline-block"
              display="block"
              bottom={12}
              right={12}
            >
              Our
            </Rule>
            <Box css="p:relative">
              <Rule
                parse="!hl d:inline-block p:relative"
                display="block"
                css="--blue-gradient-text"
                bottom={0}
                style={{ marginBottom: 0 }}
              >
                Core Values
                <BlueUnderline />
              </Rule>
            </Box>
          </Box>

          <FeaturesContainer
            items={[
              {
                title: "Growth Mindset",
                description:
                  "We grow by accepting challenges that stretch us outside of our comfort zone. These experiences shape us, and we come out of them stronger.",
              },
              {
                title: "Lead with Empathy",
                description:
                  "We work from a place of empathy first in everything we do. It's how we build our product, support our customers and each other here at Broadway Media.",
              },
              {
                title: "Dream Big",
                description:
                  "We've made it this far because we dream big! Formulate plans to achieve them, and support each other along the way.",
              },
              {
                title: "Push the Pace",
                description:
                  "We play to win. That means raising our standards, increasing velocity, narrowing our focus, pushing the pace and achieving our goals.",
              },
              {
                title: "Owner's Mentality",
                description:
                  "Broadway Media employees are empowered to identify challenges that need to be solved, take ownership, formulate a plan, and execute on that.",
              },
              {
                title: "Innovate Fearlessly",
                description:
                  "We embrace change, foster creativity, and boldly explore new horizons, driving progress and shaping the future of theatre world!",
              },
            ]}
          />
        </div>
      </ReusableSection>
      <ReusableSection>
        <div className="container">
          <Row gutter={[36, 18]} align="middle">
            <Col xs={24} sm={24} md={12}>
              <DesignedCard
                size="16x9"
                image="/assets/section/careers-1.webp"
              />
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Rule parse="!hs d:block mb:24 c:?font1">
                Remote First, Remote Always
              </Rule>
              <Rule parse="!ht d:block mb:24 c:?font2">
                We have been 100% remote since 2021. We’ve accomplished
                incredible things alongside an incredibly diverse team; all
                while living wherever our hearts desire.
              </Rule>
              <Rule parse="!ps d:block mb:24 c:?font3">
                We wholeheartedly embrace remote work and a distributed
                workforce for several compelling reasons. Firstly, it allows us
                to tap into a global pool of talent, ensuring we assemble
                diverse and skilled teams that bring fresh perspectives to our
                projects. This diversity fuels innovation, creativity, and
                problem-solving, ultimately leading to better outcomes.
              </Rule>
              <DesignedButton href={jobsLink} label="See Open Positions" />
            </Col>
          </Row>
        </div>
      </ReusableSection>
    </CatalogLayout>
  );
}

export const getServerSideProps = async ({ resolvedUrl }) => {
  return {
    props: {
      resolvedUrl,
    },
  };
};
